const INLINE_SCHEMES = ["data:", "blob:"];
const LOCAL_FILE_SCHEME = "file:";

export const UPLOADABLE_IMAGE_TYPES = ["image/png", "image/jpeg", "image/gif", "image/webp"];

export const carriesUploadableImage = (transfer: DataTransfer | null): boolean =>
  Array.from(transfer?.files ?? []).some((file) => UPLOADABLE_IMAGE_TYPES.includes(file.type));

const isOwnImage = (image: HTMLImageElement, allowedOrigins: string[]): boolean => {
  if (image.hasAttribute("data-upload-id")) return true;
  const src = image.getAttribute("src") ?? "";
  if (INLINE_SCHEMES.some((scheme) => src.startsWith(scheme))) return true;
  try {
    return allowedOrigins.includes(new URL(src, allowedOrigins[0]).origin);
  } catch {
    return false;
  }
};

export const stripExternalImages = (
  html: string,
  allowedOrigins: string[],
): { html: string; removedCount: number; removedFromLocalFilesCount: number } => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const external = Array.from(doc.querySelectorAll("img")).filter((image) => !isOwnImage(image, allowedOrigins));
  if (external.length === 0) return { html, removedCount: 0, removedFromLocalFilesCount: 0 };
  const removedFromLocalFilesCount = external.filter((image) =>
    (image.getAttribute("src") ?? "").startsWith(LOCAL_FILE_SCHEME),
  ).length;
  external.forEach((image) => image.remove());
  return { html: doc.body.innerHTML, removedCount: external.length, removedFromLocalFilesCount };
};

export const isExternalImageOnlyPaste = (html: string, allowedOrigins: string[]): boolean => {
  const { html: kept, removedCount } = stripExternalImages(html, allowedOrigins);
  if (removedCount === 0) return false;
  const rest = new DOMParser().parseFromString(kept, "text/html").body;
  return rest.textContent?.trim() === "" && rest.querySelector("img") === null;
};
